import React from "react";
import { Provider } from "react-redux";
import store from "./store";
var TransReportsCenterProvider = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ React.createElement(Provider, {
            store: store
        }, /*#__PURE__*/ React.createElement(WrappedComponent, props));
    };
};
export default TransReportsCenterProvider;

//# sourceMappingURL=TransReportsCenterProvider.js.map